import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GuidedProcessSupportBlock } from '../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { SideBarContent } from '../../../global/components/layout/sidebar-content';
import { TcsmModal } from '../../../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getPodsContent } from '../../../global/ducks/epi-api';
import { TcsmStates } from '../../../root/tcsm-model';
import { DisabilityData, MyCpgPodsSettings, PodContent } from '../mycpg-pod-models';


interface Props {
	settings: MyCpgPodsSettings;
}
export function DisabilityPlanDetail(props: Props) {

	const { settings } = props;
	const disabilityPlan = useSelector<TcsmStates, DisabilityData>(state => state?.mycpgPodsState?.pods?.disability_data);
	const [content, setContent] = useState<any>({});
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [modalContent, setModalContent] = useState<any>('');
	const notEnrolled = disabilityPlan?.disability_ltd_content === PodContent.NOT_ENROLLED && disabilityPlan?.disability_std_content === PodContent.NOT_ENROLLED;
	const contentTemp = {};

	const onContentSuccess = (key, html) => {
		contentTemp[key] = html;
		setContent({ ...contentTemp });
	};

	useEffect(() => {

		disabilityPlan?.long_term_disabilities?.forEach((l) => {
			if (l?.content_path) {
				dispatch(getPodsContent(l?.content_path, (data) => onContentSuccess(l?.content_path, data?.contentHtml)));
			}
			if (l?.plan_details) {
				dispatch(getPodsContent(l?.plan_details, (data) => onContentSuccess(l?.plan_details, data?.contentHtml)));
			}
		});

		disabilityPlan?.short_term_disabilities?.forEach((s) => {
			if (s?.content_path) {
				dispatch(getPodsContent(s?.content_path, (data) => onContentSuccess(s?.content_path, data?.contentHtml)));
			}
			if (s?.plan_details) {
				dispatch(getPodsContent(s?.plan_details, (data) => onContentSuccess(s?.plan_details, data?.contentHtml)));
			}
		});


	}, []);



	const handleClose = () => {
		setOpen(false);
	};


	const onPlanDetailClick = (plan: string) => {
		setModalContent(content[plan]);
		setOpen(true);
	};


	const renderDetailSection = () => {

		return (
			<>
				<TcsmModal
					open={open}
					handleClose={handleClose}
				>
					<WysiwygWithReactLink content={modalContent} />
				</TcsmModal>
				{
					disabilityPlan?.disability_std_content === PodContent.CONTENT &&
					<DividerSection sectionText={settings?.shortTermSectionTitle}>
						{
							disabilityPlan?.short_term_disabilities?.map((s, idx) =>
								<div key={idx}>
									{
										s?.content_path &&
										<ContentSpacer>
											<WysiwygWithReactLink content={content[s?.content_path]} />
										</ContentSpacer>
									}
									{
										s?.plan_details &&
										<button className='link-button' type='button' onClick={() => onPlanDetailClick(s?.plan_details)}>{settings?.planDetailButtonLabel}</button>
									}
								</div>)
						}

					</DividerSection>
				}
				{
					disabilityPlan?.disability_ltd_content === PodContent.CONTENT &&
					<DividerSection sectionText={settings?.longTermSectionTitle}>
						{
							disabilityPlan?.long_term_disabilities?.map((l, idx) =>
								<div key={idx}>
									{
										l?.content_path &&
										<ContentSpacer>
											<WysiwygWithReactLink content={content[l?.content_path]} />
										</ContentSpacer>
									}
									{
										l?.plan_details &&
										<button className='link-button' type='button' onClick={() => onPlanDetailClick(l?.plan_details)}>{settings?.planDetailButtonLabel}</button>
									}
								</div>)
						}

					</DividerSection>
				}
			</>

		);
	};




	return (
		<>
			<PageHeader headerText={settings?.disabilityDetailTitle} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={settings?.disabilityGpsTitle} contents={settings?.disabilityGps} />
				</SideBarContent>
			</Hidden>
			{
				notEnrolled ?
					<DividerSection removeDivider>
						<WysiwygWithReactLink content={settings?.disabilityPlanNotEnrolledMessage} />
					</DividerSection> :
					renderDetailSection()
			}
		</>
	);

}

